export default "__VITE_ASSET__Bj8yIaOP__"